export default "__VITE_ASSET__BzMSNalZ__"